export const colors = { yellow: '#fade01', orange: '#FF6A49', blue: '#01A8BF', green: '#AFDC3C' }
